"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _lodash = require("lodash");
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _lab = require("@material-ui/lab");
var _axios = _interopRequireDefault(require("axios"));
var _queryString = _interopRequireDefault(require("query-string"));
var _resolveImage = _interopRequireDefault(require("../../utils/resolveImage"));
var _elementHeadline = _interopRequireDefault(require("../../components/element-headline"));
var _searchField = _interopRequireDefault(require("../../components/search-field"));
var _sectionFilter = _interopRequireDefault(require("../../components/section-filter"));
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _useInViewport = _interopRequireDefault(require("../../hooks/useInViewport"));
var _infoAZ = _interopRequireDefault(require("../../services/infoAZ"));
var _changeLanguage = _interopRequireDefault(require("../../utils/changeLanguage"));
var _searchButton = _interopRequireDefault(require("./search-button"));
var _references = _interopRequireDefault(require("../../components/references"));
var _image = _interopRequireDefault(require("../../helper/image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    overflow: "hidden",
    padding: "env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)",
    paddingLeft: "40px",
    position: "relative",
    [theme.breakpoints.up("md")]: {
      paddingLeft: theme.spacing(4)
    }
  }
}));
const sortItemsByFirstLetter = items => {
  return items === null || items === void 0 ? void 0 : items.sort((a, b) => {
    return a.title.localeCompare(b.title);
  });
};
const filterItemsByPagename = (items, pagename) => {
  return items === null || items === void 0 ? void 0 : items.filter(item => {
    return item.pagename === pagename;
  });
};
const getFilterByItems = items => {
  let filters = [];
  let previousFirstLetter = "";
  items === null || items === void 0 || items.forEach(item => {
    let firstLetter = item === null || item === void 0 ? void 0 : item.title.charAt(0);
    if (previousFirstLetter !== firstLetter) {
      filters.push(firstLetter);
      previousFirstLetter = firstLetter;
    }
  });
  return filters;
};
const Anchor = _ref => {
  let {
    item,
    children,
    onScroll
  } = _ref;
  const ref = (0, _react.useRef)();
  const isVisible = (0, _useInViewport.default)(ref);
  if (isVisible) {
    (0, _lodash.delay)(() => onScroll(item), 100);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    id: "letter-".concat(item)
  }, children);
};
const List = _ref2 => {
  let {
    data,
    lang,
    providers,
    selected,
    onChange,
    onScroll
  } = _ref2;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const history = (0, _reactRouterDom.useHistory)();
  const theme = (0, _styles.useTheme)();
  const css = useStyles();
  const handleChange = item => {
    history.push("/".concat(lang, "/info-az/letter/").concat(item.value).concat(providers ? "?providers=".concat(providers) : ""));
  };
  const handleSearch = value => {
    var _value$title;
    history.push("/".concat(lang, "/info-az/search/").concat((_value$title = value === null || value === void 0 ? void 0 : value.title) !== null && _value$title !== void 0 ? _value$title : "").concat(providers ? "?providers=".concat(providers) : ""));
  };
  let previousFirstLetter = "";
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.root
  }, /*#__PURE__*/_react.default.createElement(_sectionFilter.default, {
    allOptions: _infoAZ.default,
    availableOptions: getFilterByItems(data),
    selected: selected,
    onChange: !!data.length ? item => onChange(item === null || item === void 0 ? void 0 : item.value) : handleChange
  }, /*#__PURE__*/_react.default.createElement(_searchButton.default, {
    lang: lang
  })), !!data.length ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.map(_ref3 => {
    let {
      id,
      media = [],
      title,
      description,
      urls = []
    } = _ref3;
    let anchor = false;
    let firstLetter = title.charAt(0);
    if (previousFirstLetter !== firstLetter) {
      anchor = true;
      previousFirstLetter = firstLetter;
    }
    const image = (0, _lodash.first)(media === null || media === void 0 ? void 0 : media.filter(item => {
      return item === null || item === void 0 ? void 0 : item.subFormats;
    }).map(item => {
      return (0, _lodash.first)((0, _resolveImage.default)(item === null || item === void 0 ? void 0 : item.subFormats, "guestinformation-large"));
    }));
    const {
      filename,
      alt,
      height,
      width
    } = image || {};
    return /*#__PURE__*/_react.default.createElement(_core.Box, {
      key: id,
      my: 6
    }, anchor && /*#__PURE__*/_react.default.createElement(Anchor, {
      item: firstLetter,
      onScroll: () => onScroll(firstLetter)
    }), /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
      title: title
    }), /*#__PURE__*/_react.default.createElement(_core.Box, {
      mt: 2
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      component: "div",
      dangerouslySetInnerHTML: {
        __html: description
      }
    })), !(0, _lodash.isEmpty)(image) && /*#__PURE__*/_react.default.createElement(_core.Box, {
      mt: 4
    }, /*#__PURE__*/_react.default.createElement(_image.default, {
      itemStyle: css.image,
      filename: filename,
      height: height,
      width: width,
      alt: alt
    })), urls.length > 0 && /*#__PURE__*/_react.default.createElement(_references.default, {
      data: {
        elements: [...urls]
      },
      isExtended: true
    }));
  })) : /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 4
  }, /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    severity: "error"
  }, t("site.ui.errors.noEntriesFound"))), /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
    title: t("site.ui.headlines.searchFor")
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 2,
    mt: 2.5
  }, /*#__PURE__*/_react.default.createElement(_searchField.default, {
    background: theme.palette.common.white,
    placeholder: t("site.ui.search.placeholders.enterQuery"),
    onChange: handleSearch
  }))));
};
const LayoutInfoAZDetail = _ref4 => {
  var _queryString$parse$pr, _queryString$parse, _data$data, _data$data2;
  let {
    match,
    location
  } = _ref4;
  const {
    search
  } = location;
  const {
    id,
    mode,
    lang
  } = match.params;
  const {
    REACT_APP_PATH,
    REACT_APP_PROVIDER_ID
  } = process.env;
  const [pageData, setPageData] = (0, _react.useContext)(_pageContext.default);
  const [providers] = (0, _react.useState)((_queryString$parse$pr = (_queryString$parse = _queryString.default.parse(search)) === null || _queryString$parse === void 0 ? void 0 : _queryString$parse.providers) !== null && _queryString$parse$pr !== void 0 ? _queryString$parse$pr : "");
  const [clicked, setClicked] = (0, _react.useState)(false);
  const [item, setItem] = (0, _react.useState)(id);
  const [selected, setSelected] = (0, _react.useState)(id);
  const [lockScroll, setLockScroll] = (0, _react.useState)(true);
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  (0, _react.useEffect)(() => {
    var _pageData$data;
    if ((pageData === null || pageData === void 0 ? void 0 : pageData.theme) === "grey" && (pageData === null || pageData === void 0 || (_pageData$data = pageData.data) === null || _pageData$data === void 0 || (_pageData$data = _pageData$data.meta) === null || _pageData$data === void 0 ? void 0 : _pageData$data.title) === t("site.ui.pagetitles.infoAZ")) {
      return;
    }
    const additionalPageData = {
      ...pageData,
      theme: "grey"
    };
    additionalPageData.data = {
      ...pageData.data,
      meta: {
        title: t("site.ui.pagetitles.infoAZ")
      }
    };
    setPageData(additionalPageData);
  }, [pageData, setPageData, t]);
  const scrollToElement = item => {
    const element = document.body.querySelector("#letter-".concat(item));
    if (!element) return;
    window.scrollTo({
      top: element.offsetTop - 20,
      behavior: "smooth"
    });
    (0, _lodash.delay)(() => {
      setLockScroll(false);
    }, 1000);
  };
  (0, _react.useEffect)(() => {
    let duration = 1000;
    if (clicked) duration = 0;
    (0, _lodash.delay)(() => {
      scrollToElement(item);
    }, duration);
  }, [item, clicked]);
  let url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListInfo.api?lang=").concat(lang, "&pageSize=9999");
  if (mode === "group") {
    url += "&groups=".concat(id);
  } else if (mode === "search") {
    url += "&keyword=".concat(id, "&providers=").concat(providers ? providers : REACT_APP_PROVIDER_ID);
  } else {
    url += "&providers=".concat(providers ? providers : REACT_APP_PROVIDER_ID);
  }
  const {
    data,
    status
  } = (0, _reactQuery.useQuery)(["list-info", lang, providers, id], () => _axios.default.get(url));
  if (status !== "success") return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (lang !== i18n.language) {
    (0, _changeLanguage.default)(i18n, lang);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const handleChange = item => {
    setClicked(true);
    setLockScroll(true);
    setSelected(item);
    setItem(item);
  };
  const handleScroll = item => {
    if (lockScroll) return;
    setSelected(item);
  };
  let items = sortItemsByFirstLetter(data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.items);
  if (mode === "detail") {
    items = filterItemsByPagename(items, "/".concat(i18n.language, "/info/").concat(id).concat(providers ? "?providers=".concat(providers) : ""));
  }
  return /*#__PURE__*/_react.default.createElement(List, {
    data: items,
    lang: lang,
    providers: providers,
    selected: selected.length === 1 ? selected : getFilterByItems(sortItemsByFirstLetter(data === null || data === void 0 || (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.items))[0],
    onChange: handleChange,
    onScroll: handleScroll
  });
};
var _default = exports.default = LayoutInfoAZDetail;